<template>
  <div class="articleInfo" ref='vantaRef'>
    <div class="content">
      <div class="left">
         <SideContent title="站长推荐" @getDetail="getDetail" :list="list" style="margin: 30px 0;"/>
         <SideContent title="点击排行" @getDetail="getDetail" :list="list1"/>
      </div>
      <div class="right">
        <el-card style="border-radius: 14px;">
          <h1>{{article.title}}</h1>
          <span>文章</span><span>{{article.num}}人已阅读</span>
          <div v-html="article.content">
          </div>
          <div class="recommend">
            <div v-if="article.up" @click="getArticleInfo(article.up.id)">上一篇：{{article.up ? article.up.title : ''}}</div>
            <div v-if="article.down" @click="getArticleInfo(article.down.id)">下一篇：{{article.down ? article.down.title : ''}}</div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import SideContent from '../../components/SideContent.vue'
  import {animateBg} from '../../utils/mixins.js'
  export default{
    name:'ArticleInfo',
    components:{
      SideContent
    },
    mixins:[animateBg],
    data(){
      return {
        id:0,
        article:{},
        list:[],
        list1:[]
      }
    },
    created() {
      this.id = this.$route.params.id
      this.getArticleInfo(this.id)
      this.getRecomandList()
      this.getClickRank()
    },
    methods:{
      getDetail(id){
       this.getArticleInfo(id)
      },
      getArticleInfo(id){
        const timestamp = Date.now()
        this.$api.getArticleDetail({t:'json',timestamp,id})
        .then(res=>{
          if(res.code == 0){
            this.article = res.data
          }else{
            console.log(res.msg)
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },
      // 获取站长推荐
      getRecomandList(){
        const timestamp = Date.now()
        this.$api.getRecList({t:'json',timestamp})
        .then(res=>{
          if(res.code == 0){
            this.list = res.data
          }else{
            console.log(res.msg)
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },
      // 点击排行
      getClickRank(){
        const timestamp = Date.now()
        this.$api.getClickRank({t:'json',timestamp})
        .then(res=>{
          if(res.code == 0){
            this.list1 = res.data
          }else{
            console.log(res.msg)
          }
        })
        .catch(err=>{
          console.log(err)
        })
      }
    }
  }
</script>

<style lang="scss">
  .articleInfo{
    background-color: #F5F7FA;
    margin-top: 20px;
    height: calc(100vh - 120px);
    // min-height: calc(100vh - 129px - 20px);
    .content{
      display: flex;
      justify-content: space-between;
      background-color: rgba(999, 999, 999, .6);
      width: 60%;
      padding-bottom:60px;
      margin: 0 auto;
      .left{
         width: 28%;
         margin-left: 20px;
      }
      .right{
        width: 68%;
        margin-right: 20px;
        position: relative;
        height:calc(100vh - 122px);
        overflow-y: scroll;
        overflow-x: hidden;
        .recommend{
          text-align: left;
          div{
            cursor: pointer;
            padding: 5px 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/articleInfo/index.vue